

import { is } from "date-fns/locale";
import axios from "../libs/axios.lib"; // We import this primarily to get the configured baseURL.
import * as loginUtils from "../utils/login.utils"; // Import your existing login utility.

const API_BASE_URL = axios.defaults.baseURL || "http://127.0.0.1:5000";

/**
 * This module centralizes the API communication for the Loc8 AI Agent.
 * It is designed to be consistent with the project's existing API patterns,
 * using the pre-configured Axios instance for the base URL and handling
 * authentication tokens automatically.
 *
// Get the base URL from your central Axios configuration.
// Fallback to a default if it's not set.


/**
 * Invokes the AI agent with a user prompt and returns the raw streaming response.
 *
 * @param {string} prompt The user's message to the agent.
 * @param {string} conversationId The unique ID for the current chat session.
 * @returns {Promise<Response>} A promise that resolves to the raw fetch Response object.
 * @throws {Error} Throws an error if the API call fails.
 */



export async function invokeAgentAPI(prompt, conversationId, creativeBase64, isVisualMode) {
  try {
    // Get the user token, just like in your other API functions.
    const token = loginUtils.getUser()?.token;

    const headers = {
      "Content-Type": "application/json",
    };

    // If a token exists, add the Authorization header.
    if (token) {
      headers["Authorization"] = token;
    }


    const response = await fetch(`${API_BASE_URL}/agent/invoke`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        prompt: prompt,
        conversation_id: conversationId, 
        creativeBase64:creativeBase64,// ✅ Send the conversation ID for memory
        mode: isVisualMode == true ? "visual" : "normal" // ✅ Send the mode (visual or text)
      }),
    });

    console.log("Agent API response status:", response.status);
    if (!response.ok) {
      // Provide more detailed error info if the request fails.
      const errorBody = await response.text();
      throw new Error(
        `API request failed with status ${response.status}: ${errorBody}`
      );
    }

    return response;
  } catch (error) {
    console.error("Agent API call failed:", error);
    // Re-throw the error to be handled by the calling component.
    throw error;
  }
}
